const enabled = () =>
  process.env.REACT_APP_LOAD_TEST_AUTH_ENABLED === 'true';

export function isLoadTestAuthEnabled() {
  return enabled();
}

export function getLoadTestUser() {
  if (!enabled()) return '';
  return localStorage.getItem('loadTestUser') || 'loadtest-browser';
}

export function getLoadTestRun() {
  if (!enabled()) return '';
  return localStorage.getItem('loadTestRun') || 'browser';
}

export function loadTestHeaders() {
  if (!enabled()) return {};
  const secret = process.env.REACT_APP_LOAD_TEST_AUTH_SECRET;
  const user = getLoadTestUser();
  if (!secret || !user.startsWith('loadtest-')) return {};
  return {
    'X-Load-Test-Secret': secret,
    'X-Load-Test-User': user,
    'X-Load-Test-Run': getLoadTestRun(),
  };
}
